import { ConfigParamsService } from '../../services/configParameters/config-params.service';
import { TutorialDialogComponent } from '../tutorial-dialog/tutorial-dialog.component';
import { NotificationDialogComponent } from '../notification-dialog/notification-dialog.component';
import { Component, OnInit, OnChanges, SimpleChanges, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material';
import { MatDialog } from '@angular/material';
import { EditionLayer } from '../../models/edition-layer';
import * as ol from 'openlayers';
import { MapService } from '../../services/map/map.service';
import { LoginService } from '../../services/login/login.service';
import {Router} from '@angular/router';
declare var proj4;


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, OnChanges {
  public static estatsList = null;
  public static readonly ZOOM_STYLE_CHANGE = 3;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @Output() isItemListOpen: EventEmitter<boolean> = new EventEmitter();
  @Output() sidenavReady: EventEmitter<MatSidenav> = new EventEmitter();
  @Output() featureClicked = new EventEmitter<any>();
  //@Output() createNewFeature = new EventEmitter<any>();
  // mapa de l'aplicació
  public map: ol.Map;
  @Input() zoomToExtent: number;
  @Input() actualThematic: string;
  @Input() getGeolocation: number;
  @Input() showMapWithThisLayer: EditionLayer;
  @Input() hasToRefreshMap: boolean;
  @Input() modifyPositionFeature: any;
  @Input() editionLayerObtainedFromGisWeb;

  public isPointLayer = false;
  public layerFeatures: any[] = [];
  public layers = [];
  private location = {};
  private editionLayerVector: ol.layer.Vector;
  private editionLayerConfig: EditionLayer;
  private locationMarkersLayers: ol.layer.Vector;
  private mapDiv: any;
  private mapConfigurationParameters = null;
  private geoServerURL: string;
  private localizedMarker: ol.Feature;
  private restricted_extent: [number, number, number, number];
  private config: any;
  private isHttps = false;
  private isShowNewFeature = true;
  private isShowModFeature = true;
  public loadingWFS = true;
  public errorLoadingWFS = false;
  private layerEdition = null;
  private selectInteraction = null;
  private vectorSource = null;
  // Selector
  streetCtrl = new FormControl();

  constructor(public dialog: MatDialog,
    protected configParamsService: ConfigParamsService,
    private mapService: MapService,
    private loginService: LoginService,
    private router: Router) {
    // Definim la projeccio i creem un mapa buit
    this.defineProjections();
    this.streetCtrl = new FormControl();

  }

  ngOnInit() {
    setTimeout(() => {
      if (this.sidenav) {
        this.sidenavReady.emit(this.sidenav);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (typeof (changes.showMapWithThisLayer) !== 'undefined' && changes.showMapWithThisLayer.currentValue) {
      this.initMap();
      console.log('MapComponent >>> Changes >>>> init map and add layer');
      this.addEditionLayer(changes.showMapWithThisLayer.currentValue);
    }
    if (typeof (changes.hasToRefreshMap) !== 'undefined' && changes.hasToRefreshMap.currentValue) {
      console.log('MapComponent >>> Changes >>>> refresh edition layer');
      this.refreshEditionLayer();

    }
    if (typeof (changes.modifyPositionFeature) !== 'undefined' &&
      typeof (changes.modifyPositionFeature.currentValue.editionLayer) !== 'undefined' &&
      typeof (changes.modifyPositionFeature.currentValue.olFeature) !== 'undefined') {
      this.showModifyPosition(changes.modifyPositionFeature.currentValue);
    }
  }

  ngAfterContentInit() {

  }

  public hasToShowAddButton(){
    return this.isShowNewFeature  && this.isShowModFeature && this.isPointLayer;
  }

  public toggleShowExpansionListButton() {
    this.sidenav.open();
    this.isItemListOpen.emit(true);
  }

  public initMap() {
    try {
      this.isHttps = window.isSecureContext;
      this.config = this.configParamsService.getConfig();
      this.mapConfigurationParameters = this.config.map;
      MapComponent.estatsList = this.config.states;
      this.geoServerURL = this.config.geoserver;
      this.restricted_extent = this.mapConfigurationParameters.restricted_extent;
      if (typeof (this.map) !== 'undefined') {
        document.getElementById('map').innerHTML = '';
      }
      this.map = new ol.Map({
        target: 'map',
        controls: ol.control.defaults({ attribution: false, rotate: false, zoom: false }),
        interactions: ol.interaction.defaults({ altShiftDragRotate: false, pinchRotate: false }),
        view: new ol.View({
          center: this.mapConfigurationParameters.center,
          extent: this.restricted_extent,
          zoom: 0,
          projection: this.mapConfigurationParameters.projection,
          resolutions: this.mapConfigurationParameters.resolutions
        })
      });

      this.addBaseLayers();

      //afegim capa markers per mostrar el resultat de la cerca
      this.locationMarkersLayers = this.createVectorLayer(
        { 'id': 'markers_layer' }
        , new ol.style.Style({
          image: new ol.style.Icon({
            src: 'assets/mapIcons/marker.png'
          })
        })
      );

      this.map.on('singleclick', (event: any) => {
        let features = event.map.getFeaturesAtPixel(event.pixel, { hitTolerance: 10 });
        if (features.length > 0) {
          let obj = {
            'feature': features[0],
            'layer': this.editionLayerConfig
          }
          this.featureClicked.emit(obj);
        }
      });
      if (!this.configParamsService.isPrivateApp()) {
        setTimeout(() => {
          this.openHelpDialog();
        });
      }

    } catch (ex) {
      console.error('Error trying to inicialize map', ex);
    }

  }


  private addLayerToMap(layer: Object, baselayer: boolean, isvisible: boolean): void {
    console.debug('>>> Map.Component - addLayerToMap');
    let newBaseLayer;
    let params_ = {};
    for (let index in layer) {
      if (index !== 'thumbnail') {
        params_[index.toUpperCase()] = layer[index];
      }

    }
    delete params_['URL'];
    delete params_['ID'];
    delete params_['TITLE'];

    if (layer['OSM']) {
      newBaseLayer = new ol.layer.Tile({
        visible: isvisible,
        source: new ol.source.OSM()
      });
    } else if (typeof (layer['tiled']) !== 'undefined' && layer['tiled']) {
      newBaseLayer = new ol.layer.Tile({
        extent: this.restricted_extent,
        //visible: (aplicacio.funcionalitat.baseButtons.visible === 'true' && serviceId === aplicacio.funcionalitat.baseButtons[1].service) || isBaseLayer.length==0 ,//si és el primer servei del base buttons, serà visible/
        visible: isvisible,//si és el primer servei del base buttons, serà visible
        source: new ol.source.TileWMS({
          url: layer['url'],
          params: params_,
          projection: layer['srs']
        })
      });
    } else {
      newBaseLayer = new ol.layer.Image({
        extent: this.restricted_extent,
        visible: isvisible,
        source: new ol.source.ImageWMS({
          url: layer['url'],
          projection: layer['srs'],
          params: params_,
          ratio: 1
        })
      });
    }


    newBaseLayer.setProperties(layer, true);

    if (baselayer) {
      this.layers.push(newBaseLayer);
    }

    this.map.addLayer(newBaseLayer);

  }

  public mapZoomToExtent(hasTo): void {
    if (hasTo > 0) {
      this.map.getView().fit(this.restricted_extent);
    }
  }

  public openHelpDialog(): void {
    try {
      let width = window.innerWidth * 0.80;
      if (width > 350) {
        width = 350;
      }

      const tutorialMessageKeys = [
        'tutorial.content.pas1',
        'tutorial.content.pas2',
        'tutorial.content.pas3',
        'tutorial.content.pas4'
      ];

      const dialogRef = this.dialog.open(TutorialDialogComponent, {
        width: width + 'px',
        data: { messages: tutorialMessageKeys }
      });

      dialogRef.afterClosed().subscribe(() => {
        console.log('The dialog was closed');
      });
    } catch (ex) {
      console.error('Error trying to open the dialog', ex);
    }
  }

  public openNotificationDialog(status, message): void {
    try {
      let width = window.innerWidth * 0.80;
      if (width > 385) {
        width = 449;
      }
      let dialogRef = this.dialog.open(NotificationDialogComponent, {
        width: width + 'px',
        data: {
          header: status,
          status: status,
          message: message
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });

    } catch (ex) {
      console.error('Error trying to open the dialog', ex);
    }
  }

  private defineProjections() {
    console.debug('>>> MapComponent: defineProjections');
    /*ol.proj.addProjection(new ol.proj.Projection({
      code: 'EPSG:27563', units: 'm', extent: [259903.04, 11878.63, 1020120.16, 363730.57]
    }));*/
    proj4.defs([
      ['EPSG:54004', '+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs'],
      ['EPSG:23029', '+proj=utm +zone=29 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'],
      ['EPSG:23031', '+proj=utm +zone=31 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'],
      ['EPSG:23030', '+proj=utm +zone=30 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'],
      ['EPSG:4269', '+proj=utm +zone=32 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'],
      ['EPSG:25829', '+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
      ['EPSG:25830', '+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
      ['EPSG:25831', '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
      ['EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
      ['EPSG:32629', '+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs'],
      ['EPSG:32630', '+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs'],
      ['EPSG:32631', '+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs'],
      ['EPSG:32632', '+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs'],
      ['EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs'],
      ['EPSG:4230', '+proj=longlat +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +no_defs'],
      ['EPSG:4258', '+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs']
    ]);
  }

  public addBaseLayers() {
    let baseLayers = this.mapConfigurationParameters.layers;
    for (let index in baseLayers) {
      let configLayer = baseLayers[index];
      this.addLayerToMap(configLayer, true, configLayer.id === 1);
    }
  }

  public changeBaseLayer(newthematic) {
    for (const index in this.layers) {
      this.layers[index].setVisible(false);
    }
    newthematic.setVisible(true)
  }

  public createVectorWFSLayer(properties: {nom_capa, geometria_tipus}, style: ol.style.Style[]): ol.layer.Vector {

    if (this.editionLayerVector !== null) {
      this.map.removeLayer(this.editionLayerVector);
      this.vectorSource = null;
    }

    this.isPointLayer =properties.geometria_tipus.toLowerCase() === "point";

    this.mapService.getFeatures(properties.nom_capa,this.loginService.getUsername()).then((response) => {
      if (response && response.hasOwnProperty("features")) {
        this.layerFeatures = response["features"];
        this.sortFeatures();
      } else {
        this.layerFeatures = [];
        this.loadingWFS = false;
      }
      this.vectorSource.addFeatures(
        new ol.format.GeoJSON().readFeatures(response, {
          dataProjection: this.map.getView().getProjection(),
          featureProjection: this.map.getView().getProjection()
        })
      );
      setTimeout(() => { this.loadingWFS = false; }, 300);
    }).catch(() => {
      this.loadingWFS = false;
      this.errorLoadingWFS = true;
      console.info('No s\'han retornat features, no s\'en mostraran al mapa');
    });

    this.vectorSource = new ol.source.Vector({
      features:[]
    });

    let layer = new ol.layer.Vector({
      source: this.vectorSource,
      style: (feature: ol.Feature, resolution: any) => {
        if (this.editionLayerConfig.nom_camp_etiqueta.length > 0 && resolution < 2) {
          let style_ = [];
          let textLabel = feature.get(this.editionLayerConfig.nom_camp_etiqueta);
          style_.push(
            this.getLabelStyle(textLabel, this.editionLayerConfig)
          )
          return style_.concat(style);
        }
        this.loadingWFS = false;
        return style;
      }
    });

    layer.setProperties(properties);
    this.map.addLayer(layer);
    return layer;
  }

  private sortFeatures(): void {
    this.layerFeatures = this.layerFeatures.sort((a, b) => a.properties.gid - b.properties.gid);
  }


  private getLabelStyle(textLabel: any, editionLayer: EditionLayer): any {
    let estil = editionLayer.getTextStyle();
    if (estil.length > 0) {
      return new ol.style.Style({
        text: new ol.style.Text({
          text: textLabel + '',
          offsetY: 20,
          font: estil[0].mida_etiqueta + ' RobotoCondensed',
          stroke: new ol.style.Stroke({ color: '#fff', width: 3 }),
          fill: new ol.style.Fill({ color: estil[0].color_etiqueta })
        })
      });
    } else {
      return new ol.style.Style({
        text: new ol.style.Text({
          text: textLabel + '',
          offsetY: 20,
          font: '18px RobotoCondensed',
          stroke: new ol.style.Stroke({ color: '#fff', width: 3 }),
          fill: new ol.style.Fill({ color: '#00bd67' })
        })
      });
    }
  }

  public createVectorLayer(properties: object, style: ol.style.Style): ol.layer.Vector {
    let fotodenunciesLayer = this.mapConfigurationParameters.fotodenunciesLayer;
    let layer = new ol.layer.Vector({
      source: new ol.source.Vector(),
      style: (feature: ol.Feature, resolution: any) => {
        const listStyles = [];
        listStyles.push(style);
        return listStyles;
      }
    });
    layer.setProperties(properties);
    this.map.addLayer(layer);
    return layer;
  }

  /*
  * -------------------------------------------------
  * Et mostra el mapa amb la teva geolocalització actual.
  * Requisits: Servidor amb SSL (HTTPS)
  * -------------------------------------------------
  */
  private geolocateMyPosition() {
    let geolocation = new ol.Geolocation({
      projection: this.map.getView().getProjection()
    });

    geolocation.setTracking(true);

    let geolocationOnError = (event) => {
      alert(event.message);
    }

    // handle geolocation error.
    geolocation.on('error', geolocationOnError);

    let accuracyFeature = new ol.Feature();
    let geolocationOnChangeAccuracyGeometry = (event) => {
      accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
    }
    geolocation.on('change:accuracyGeometry', geolocationOnChangeAccuracyGeometry);

    let positionFeature = new ol.Feature();

    positionFeature.setStyle(
      [new ol.style.Style({
        image: new ol.style.Circle({
          radius: 18,
          fill: new ol.style.Fill({
            color: 'rgba(51,153,204,0.34)'//rgba(51,153,204,0.34)
          })
        })
      }), new ol.style.Style({
        image: new ol.style.Circle({
          radius: 10,
          fill: new ol.style.Fill({
            color: 'rgb(23,101,244)'//#3399CC
          }),
          stroke: new ol.style.Stroke({
            color: '#fff',
            width: 2
          })
        })
      })]
    );

    let geolocationOnChangePosition = (event) => {
      let coordinates = geolocation.getPosition();
      let bbox = this.restricted_extent;
      if (ol.extent.containsCoordinate(bbox, coordinates)) {
        positionFeature.setGeometry(coordinates ? new ol.geom.Point(coordinates, 'XY') : null);
        let extent = positionFeature.getGeometry().getExtent();
        this.centerWithAnimation(extent);
      }
      else {
        this.openNotificationDialog('Geolocalització', 'Actualment esteu fora del Principat. No es mostrarà la geolocalització.');
      }
      geolocation.setTracking(false);
    }

    geolocation.on('change:position', geolocationOnChangePosition);

    this.locationMarkersLayers.getSource().clear();
    this.locationMarkersLayers.getSource().addFeatures([accuracyFeature, positionFeature]);
  }

  private centerWithAnimation(extent: [number, number, number, number]): void {
    this.map.getView().fit(extent, { duration: 1000 });
  }

  public selectedCandidatHandler(event) {
    console.log(event);
    const coordenades = event.split(' ');
    this.map.getView().animate({
      center: coordenades,
      duration: 1000,
      zoom: 6
    });
    this.addLocalizedMarker(coordenades);
  }

  private addLocalizedMarker(coordenades: Array<number>) {
    this.deleteLocalizedMarker();
    this.localizedMarker = new ol.Feature({
      geometry: new ol.geom.Point([coordenades[0], coordenades[1]]),
      id: 'marker'
    });
    this.locationMarkersLayers.getSource().addFeature(this.localizedMarker);
  }

  private deleteLocalizedMarker() {
    this.locationMarkersLayers.getSource().clear();
    this.localizedMarker = null;
  }

  public getCoordinatesNewFotodenuncia(): ol.Coordinate {
    const coordinates: ol.Coordinate = this.map.getView().getCenter();
    console.log(coordinates);
    return coordinates;
  }

  public refreshEditionLayer() {
    this.editionLayerVector = this.createVectorWFSLayer(
      this.editionLayerConfig
      , this.getStylesFromProps()
    );
  }
  public getStylesFromProps(): ol.style.Style[] {
    if (typeof (this.editionLayerConfig.estils) === 'undefined' || this.editionLayerConfig.estils.length === 0) {
      return [
        new ol.style.Style({
          image: new ol.style.Circle({
            radius: 8,
            fill: new ol.style.Fill({
              color: '#00bd67'
            }),
            stroke: new ol.style.Stroke({
              color: '#ffffff', //rgb(5,55,235) blau fosquet 0,153,235 blau clareet
              width: 2
            })
          })
        })
      ];
    } else {
      let styles = [];
      for (var index = 0; index < this.editionLayerConfig.estils.length; index++) {
        let tempStyle = this.editionLayerConfig.estils[index];
        if (this.editionLayerConfig.geometria_tipus.toLowerCase() === 'point') {
          styles.push(
            new ol.style.Style({
              image: new ol.style.Circle({
                radius: tempStyle.radi_punt,
                fill: new ol.style.Fill({
                  color: tempStyle.color_interior
                }),
                stroke: new ol.style.Stroke({
                  color: tempStyle.color_border,
                  width: tempStyle.mida_border
                })
              })
            })
          );
        }
        else if (this.editionLayerConfig.geometria_tipus.toLowerCase() === 'linestring') {
          styles.push(
            new ol.style.Style({
              stroke: new ol.style.Stroke({
                color: tempStyle.color_border,
                width: tempStyle.mida_border
              })
            })
          );
        }
        else if (this.editionLayerConfig.geometria_tipus.toLowerCase() === 'polygon') {
          styles.push(
            new ol.style.Style({
              fill: new ol.style.Fill({
                color: tempStyle.color_interior
              }),
              stroke: new ol.style.Stroke({
                color: tempStyle.color_border,
                width: tempStyle.mida_border
              }),
              image: new ol.style.Circle({
                radius: 2,
                fill: new ol.style.Fill({
                  color: tempStyle.color_interior
                }),
                stroke: new ol.style.Stroke({
                  color: tempStyle.color_border,
                  width: tempStyle.mida_border
                })
              })
            })
          );
        }
      }
      return styles;
    }

  }
  public addEditionLayer(layer: EditionLayer) {
    //1. construir peticio wfs
    //2. obtenir features
    //3. afegir features al mapa
    //afegim layer de features a editar

    this.editionLayerConfig = layer;
    this.editionLayerVector = this.createVectorWFSLayer(
      layer
      , this.getStylesFromProps()
    );
    //afegim interacció de select
    //this.addSelectInteraction();
  }

  public createNewFeatureHandler() {

    let point = new ol.geom.Point(this.map.getView().getCenter());

    let newfeature = new ol.Feature({
      name: 'newfeature',
      geometry: point
    });

    this.toggleNewFeatureButton();
    this.featureClicked.emit({
      'layer': this.editionLayerConfig,
      'feature': newfeature
    });
  }

  public toggleNewFeatureButton() {
    this.isShowNewFeature = !this.isShowNewFeature;
  }

  private showModifyPosition(obj): void {
    this.isShowNewFeature = true;
    this.map.getView().setCenter(obj['olFeature'].getGeometry().getCoordinates());
    this.isShowModFeature = false;
  }


  public doModFeatureHandler(): void {
    let point = new ol.geom.Point(this.map.getView().getCenter());

    this.modifyPositionFeature['olFeature'].setGeometry(point);

    this.isShowModFeature = true;
    this.featureClicked.emit({
      'layer': this.modifyPositionFeature['editionLayer'],
      'feature': this.modifyPositionFeature['olFeature']
    });
  }

  public cancelModFeatureHandler(): void {
    this.isShowModFeature = true;
    this.featureClicked.emit({
      'layer': this.modifyPositionFeature['editionLayer'],
      'feature': this.modifyPositionFeature['olFeature']
    });
  }

  public featureToEditFromListEventHandler(event): void {
    this.sidenav.close();
    this.featureClicked.emit(event);
  }

  geolocateFeatureHandler(feature: any): void {
    this.sidenav.close();
    let coordinates = feature.getGeometry().getCoordinates();
    this.map.getView().animate({
      center: coordinates,
      duration: 2000,
      zoom: 7
    });
  }

  public getPositionFromCenter() {
    const pixelsCenter = this.map.getPixelFromCoordinate(this.map.getView().getCenter());
    return { 'position': 'fixed', 'top.px': Math.round(pixelsCenter[1]), 'left.px': pixelsCenter[0], 'margin-left.px': -25 };
  }

  protected backToLayerGrid() {
    this.loadingWFS = false;
    this.errorLoadingWFS = false;
    if (this.configParamsService.isPrivateApp()) {
      this.router.navigate(['/privat']);
    } else {
      this.router.navigate(['/public']);
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/map/map.component.ts